<template>
  <div>
    <el-form ref="searchform" :model="searchform" label-width="75px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="产品" prop="productCode">
             <el-input v-model.trim="searchform.productCode" style="width:100%" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退货日期" prop="datelist">
            <el-date-picker
              style="width:100%"
              v-model="searchform.datelist"
              type="daterange"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-button @click="resetForm('searchform')">重置</el-button>
          <el-button type="primary" @click="getreturncount()" icon="el-icon-search"> </el-button>
        </el-col>
      </el-row>
    </el-form>
    <line-chartd1 :chart-data="lineChartData" />
  </div>
</template>

<script>
import LineChartd1 from "../LineChartd1";
import { returncount } from "@/api/report";
export default {
  components: {
    LineChartd1
  },
  data() {
    return {
      lineChartData: {
        expectedData:[],
        actualData: [],
        chartdatelist: []
      },
      // 扫码查询参数
      searchform: {
        rejectedOrderType:2,
        productCode: null,
        datelist: null
      },
    };
  },
  methods: {
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 扫码查询次数
    getreturncount() {
      returncount({
        rejectedOrderType:2,
        productCode: this.searchform.productCode,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.lineChartData.actualData = [];
        this.lineChartData.chartdatelist = [];
        this.lineChartData.expectedData = [];
        for (let i = 0; i < response.data.length; i++) {
          this.lineChartData.expectedData.push(response.data[i].qrcodeqty1);
          this.lineChartData.actualData.push(response.data[i].qrcodeqty2);
          response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
          this.lineChartData.chartdatelist.push(response.data[i].createDate);
        }
      });
    },
  },
  mounted() {
    // 图表初始数据调用
    this.getreturncount();
  }
};
</script>
<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
